<template>
  <div class="culture">

   <img
    src="../assets/culture/benner.png"
    alt
    style="width: 100%; height: 210px;overflow:hidden; object-fit: cover;"
  />
  <h3>{{msg}}</h3>
   <div class="actives">
      <el-row :gutter="80">
      <el-col  v-for="(item, index) in actives" :key="index" :span="6">
      <div>
      <img
        :src="item.icon"
        alt
        style="width: 10.625rem; height: 10.625rem; margin-top: 1.875rem;margin-bottom: 1.875rem;"/>
      <span style="font-size:1.125rem;line-height:1.75rem;color: #1A1A1A;font-weight: 600;text-align: center;display: block;margin-bottom: .9375rem;">{{ item.title }}</span>
      <!-- <div v-html="item.desc" style="font-size:.875rem;line-height: 1.375rem;color: #777777;margin-bottom: 1.875rem;"></div> -->
      </div>
      </el-col>
      </el-row>
      </div>
  </div>
</template>
<style scoped>
.culture{
min-height: 100%;
min-width: 1200px;
}
h3 {
padding-top: 3.125rem;
padding-bottom: 3.125rem;
color: #1A1A1A;
font-size: 1.5rem;
}

.actives{
  width: 920px;
  max-width: 920px;
  min-width: 920px;
  display: inline-block;
  margin-bottom: 1.1875rem;
}
</style>

<script>
export default {

  data () {
  return {
   msg: '企业文化',
   actives:[
   {
     icon:require('../assets/culture/icon01.png'),
     title:'效率',
     desc:'快速前进，打破一切'
   },
   {
     icon:require('../assets/culture/icon02.png'),
     title:'质量',
     desc:'刻苦钻研，精益求精'
   },
   {
     icon:require('../assets/culture/icon03.png'),
     title:'业务',
     desc:'以用户为中心，拒绝伪需求'
   },
   {
     icon:require('../assets/culture/icon04.png'),
     title:'诚信',
     desc:'说到做到'
   },
   {
     icon:require('../assets/culture/icon05.png'),
     title:'自信',
     desc:'不小看自己，人有无限可能'
   },
   {
     icon:require('../assets/culture/icon06.png'),
     title:'学习',
     desc:'学习是一种生活方式'
   },
   {
     icon:require('../assets/culture/icon07.png'),
     title:'沟通',
     desc:'缜密思维，阳光沟通'
   },
   {
     icon:require('../assets/culture/icon08.png'),
     title:'团结',
     desc:'精诚合作，携手共进'
   },]
  };
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Culture.vue